import ApiService from './ApiService'

import HARDCODE from '../business-const/HardCode/HardCode'

import AuthService from './AuthService'

import {
    usuarioInfo,
} from './UsuarioService'



class VwClienteAcessoPendenciaService extends ApiService {

    constructor() {
        super(HARDCODE.apiVwClienteAcessoPendencia)
    }

    async buscarClienteList(variaveisGlobais, tipoPendenciaNULL, temPrevisaoNULL, pendenteNULL) {

        /*
        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`

        params = `${params}&jsonUsuarioSelecionado=${AuthService.usuarioSelecionadoList(variaveisGlobais)}`

        params = `${params}&tipoPendencia=${tipoPendencia}`

        const paramsAux = {
            params: {
                jsonLogAcessoApi: await usuarioInfo()
            }
        }

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoPendenciaBuscarClienteList}/?${params}`, paramsAux, false)
        */

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                jsonUsuarioSelecionado: AuthService.usuarioSelecionadoListString(variaveisGlobais),
                tipoPendencia: tipoPendenciaNULL,
                temPrevisao: temPrevisaoNULL,
                pendente: pendenteNULL,
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoPendenciaBuscarClienteList, body, false)
    }

    async count(variaveisGlobais, tipoPendenciaNULL, temPrevisaoNULL, pendenteNULL) {

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                jsonUsuarioSelecionado: AuthService.usuarioSelecionadoListString(variaveisGlobais),
                tipoPendencia: tipoPendenciaNULL,
                temPrevisao: temPrevisaoNULL,
                pendente: pendenteNULL,
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoPendenciaCount, body, false)
    }
    
    async countClientePendencias(variaveisGlobais) {

        /*
        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`
        
        params = `${params}&jsonUsuarioSelecionado=${AuthService.usuarioSelecionadoList(variaveisGlobais)}`

        const paramsAux = {
            params: {
                jsonLogAcessoApi: await usuarioInfo()
            }
        }

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoPendenciaCountPendencias}/?${params}`, paramsAux, false)
        */

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                jsonUsuarioSelecionado: AuthService.usuarioSelecionadoListString(variaveisGlobais),
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoPendenciaCountPendencias, body, false)
    }

    async buscarPendenciaList(variaveisGlobais, filtroList) {

        /*
        const { params, paramsAux } = await this.calculaParamsFiltroList(variaveisGlobais, null, filtroList, false)

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoPendenciaBuscarClienteAcessoPendenciaList}/?${params}`, paramsAux, false)
        */

        const body = await this.calculaBodyFiltroList(variaveisGlobais, null, filtroList, true)

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoPendenciaBuscarPendenciaList, body, false)
    }

    async countPendenciaTotal(variaveisGlobais, filtroList) {

        /*
        const { params, paramsAux } = await this.calculaParamsFiltroList(variaveisGlobais, null, filtroList, false)

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoPendenciaCountClienteAcessoPendenciaTotal}/?${params}`, paramsAux, false)
        */

        const body = await this.calculaBodyFiltroList(variaveisGlobais, null, filtroList, true)

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoPendenciaCountPendenciaTotal, body, false)
    }
    
    async countPendencia(variaveisGlobais, campoAgrupamento, filtroList) {

        /*
        const { params, paramsAux } = await this.calculaParamsFiltroList(variaveisGlobais, campoAgrupamento, filtroList, false)

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoPendenciaCountClienteAcessoPendencia}/?${params}`, paramsAux, false)
        */

        const body = await this.calculaBodyFiltroList(variaveisGlobais, campoAgrupamento, filtroList, true)

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoPendenciaCountPendencia, body, false)
    }
}

export default VwClienteAcessoPendenciaService